const EVT = "azilis:simFacilities:changed";

/** @type {{ id: string, name: string, address?: string, group: string }[]} */
let store = [];

const emit = () => {
  try {
    window.dispatchEvent(new Event(EVT));
  } catch {
    /* ignore */
  }
};

export const getSimulated = () => store;

export const hasSimulated = (id) => store.some((s) => String(s.id) === String(id));

export const addSimulated = (s) => {
  if (!s || !s.id) return;
  if (hasSimulated(s.id)) return;
  store = [...store, s];
  emit();
};

export const removeSimulated = (id) => {
  store = store.filter((x) => String(x.id) !== String(id));
  emit();
};

export const subscribeSimulated = (fn) => {
  const handler = () => fn([...store]);
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
};
